import Link from 'next/link';
import Image from 'grandus-lib/components-atomic/image/Image';

const BlogCard = ({ blog }) => {
  const { title, urlTitle, communityCategory, photo } = blog;

  const imageProps = { layout: 'responsive' };
  return (
    <article className={''}>
      <Link
        href={`/blog/${urlTitle}`}
        title={title}
        className={'flex flex-col justify-between no-underline bg-white'}
      >
        {photo ? (
          <div className={''}>
            <Image
              photo={photo}
              size={`309x360__cropped@2x`}
              type={'jpg'}
              imageProps={imageProps}
              useNextImage={true}
              alt={photo?.description || title}
            />
          </div>
        ) : (
          ''
        )}
        <div className={'border border-primary border-t-0'}>
          <div className={`px-2 py-4 h-[75px]`}>
            <span className={'line-clamp-2'}>{title}</span>
          </div>
          <footer
            className={'p-2 border-primary flex justify-between font-light'}
          >
            <small>{communityCategory?.name}</small>
          </footer>
        </div>
      </Link>
    </article>
  );
};

export default BlogCard;
